// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page{margin-bottom:150px}.settings__item{display:flex;align-items:center}.settings__item .form-control{margin-right:16px}.settings__item+.settings__item{margin-top:16px}@media(max-width:840px){.page{margin-bottom:300px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
